// extracted by mini-css-extract-plugin
export default {"last-visited-wrapper":"LastVisited_last-visited-wrapper__8KHNR"};